<template>
    <div class="col-lg-9 col-xl-6"><slot></slot></div>
</template>
